export default {
  TITLE_TAB: 'Página de bienvenida',
  ENTITY_NAME: 'Portal',
  EMAIL_IS_REQUIRED: 'Correo Electrónico es requerido',
  GENDER_IS_REQUIRED: 'Género es requerido',
  BIRTHDATE_IS_REQUIRED: 'Fecha de nacimiento es requerido',
  CREATE_PORTAL: 'Crear portal',
  EDIT_PORTAL: 'Crea tu página de bienvenida',
  SAVE_BUTTON: 'Guardar',
  MANUAL_LOGIN: 'Botón de registro por formulario',
  FACEBOOK_LOGIN: 'Botón de registro por Facebook',
  LOGO_TITLE: 'Selecciona el logo de tu empresa',
  BACKGROUND_TITLE: 'Selecciona la imagen de fondo',
  OPTIONS: 'Datos solicitados para registro formulario',
  ERROR_LOGIN: 'Debe tener una opción habilitada',
  OPTION_FIELDS: {
    EMAIL: 'Correo Electrónico',
    NAME: 'Nombre',
    LASTNAME: 'Apellido',
    GENDER: 'Género',
    BIRTHDATE: 'Fecha de nacimiento',
    PHONE: 'Celular',
  },
  DISABLE_FACEBOOK: 'Deshabilite el registro por Facebook',
  '0000': 'Asegurate de tener deshabilitado el bloqueo de Facebook en la red de clientes antes de habilitar el registro por Facebook',
}
